var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.805,
    height: 12.797,
    viewBox: "0 0 12.805 12.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15760",
    "data-name": "Path 15760",
    d: "M5.391-5.679a.3.3,0,0,0,.3-.3V-7.2a.3.3,0,0,0-.3-.3H2.9A4.461,4.461,0,0,1,6.508-9.344a4.466,4.466,0,0,1,4.469,4.469A4.466,4.466,0,0,1,6.508-.406a4.452,4.452,0,0,1-2.961-1.12.3.3,0,0,0-.416.013l-.862.862a.305.305,0,0,0,.012.442,6.274,6.274,0,0,0,4.228,1.63,6.3,6.3,0,0,0,6.3-6.283,6.282,6.282,0,0,0-6.25-6.31A6.28,6.28,0,0,0,1.828-9.087V-11.07a.3.3,0,0,0-.3-.3H.3a.3.3,0,0,0-.3.3v5.087a.3.3,0,0,0,.3.3Z",
    transform: "translate(0 11.375)",
    fill: "#cbcbd1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.a3c2a55d6ae241fede32c8c4e1d52ad3.svg";
export { ForwardRef as ReactComponent };